//@ts-ignore
import NumberInput from './numberInput.tsx';

export default NumberInput;
